import { ensureHTTPS, evaluateCondition } from '../utils/utils'

const LinkControl = ({ link, record }) => {
  if (!link || evaluateCondition(link.isHidden, record)) {
    return null;
  }

  const hrefValue = !!link.hrefField ? record[link.hrefField] : link.href;
  const href = typeof hrefValue === 'string' && hrefValue.trim().length
    ? ensureHTTPS(hrefValue.trim())
    : hrefValue;

  if(!link.onClick && !href) {
    console.error('LinkControl: link.onClick or link.href is required');
    return (<div>LinkControl: link.onClick or link.href is required</div>);
  }

  const linkedLabel = typeof link.linkedLabel === 'function' ? link.linkedLabel(record) : link.linkedLabel;
  const label = typeof link.label === 'function' ? link.label(record) : link.label;

  const linkProps = {
    href: href,
    target: link.target || '_blank',
    disabled: evaluateCondition(link.isDisabled, record),
    className: `link ${link.className ?? ''}`,
    style: link.style || {},
  };

  if(link.onClick) {
    linkProps.onClick = (e) => {
      e.preventDefault();
      link.onClick(record);
    };
    delete linkProps.href;
    delete linkProps.target;
    return (
      <div className='link-container'>
        {!!label && (
          <span>{label}</span>
        )}
        <div {...linkProps}>
          <span>{linkedLabel}</span>
          {!!link.iconClassName && (
            <i className={link.iconClassName} />
          )}
        </div>
      </div>
    )
  }
  return (
    <div className='link-container'>
      {!!label && (
        <span>{label}</span>
      )}
      <a {...linkProps}>
        <span>{linkedLabel}</span>
        {!!link.iconClassName && (
          <i className={link.iconClassName} />
        )}
      </a>
    </div>
  );
};

export default LinkControl;
